export default "__VITE_ASSET__CzMgH2BV__"